var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79289 9.29289C6.18342 8.90237 6.81658 8.90237 7.20711 9.29289L12.5 14.5858L17.7929 9.29289C18.1834 8.90237 18.8166 8.90237 19.2071 9.29289C19.5976 9.68342 19.5976 10.3166 19.2071 10.7071L13.2071 16.7071C12.8166 17.0976 12.1834 17.0976 11.7929 16.7071L5.79289 10.7071C5.40237 10.3166 5.40237 9.68342 5.79289 9.29289Z",
    fill: "#1226AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon_chevron-down.909f96351b21ab18e12fa337f8264da9.svg";
export { ForwardRef as ReactComponent };